export const APP_URL = "https://VoiceLensAI.org";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
